<template>
  <card>
    <div class="row" v-if="expostatSurveys">
      <label class="col-md-3 col-form-label" v-translate>ExpoStat survey</label>
      <div class="col-md-9">
        <el-select class="select-info"
                   :placeholder="'Select survey' | translate"
                   @change="loadExpostatSurvey"
                   v-model="currentExpostatSurvey">
          <el-option v-for="survey in expostatSurveys"
                     class="select-info"
                     :value="survey.id"
                     :label="survey.name"
                     :key="survey.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row" v-if="servers && !currentExpostatSurvey">
      <label class="col-md-3 col-form-label" v-translate>RussCom Forum Server</label>
      <div class="col-md-9">
        <el-select class="select-info"
                   :placeholder="'Select server' | translate"
                   @change="loadDatabases"
                   v-model="currentServer">
          <el-option v-for="server in servers"
                     class="select-info"
                     :value="server.host"
                     :label="server.description"
                     :key="server.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row" v-if="databases">
      <label class="col-md-3 col-form-label" v-translate>Database</label>
      <div class="col-md-9">
        <el-select class="select-info"
                   :placeholder="'Select database' | translate"
                   @change="loadSelfRegistrations"
                   v-model="currentDatabase">
          <el-option v-for="database in databases"
                     class="select-info"
                     :value="database.dbName"
                     :label="database.name"
                     :key="database.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row" v-if="selfRegistrations">
      <label class="col-md-3 col-form-label" v-translate>Self registration</label>
      <div class="col-md-9">
        <el-select class="select-info"
                   :placeholder="'Select self registration' | translate"
                   @change="selectSelfRegistration"
                   v-model="currentSelfRegistration">
          <el-option v-for="selfRegistration in selfRegistrations"
                     class="select-info"
                     :value="selfRegistration.id"
                     :label="selfRegistration.name"
                     :key="selfRegistration.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row" v-if="surveys">
      <label class="col-md-3 col-form-label" v-translate>Survey</label>
      <div class="col-md-9">
        <el-select class="select-info"
                   :placeholder="'Select survey' | translate"
                   @change="selectSurvey"
                   v-model="currentSurvey">
          <el-option v-for="survey in surveys"
                     class="select-info"
                     :value="survey.id"
                     :label="survey.name"
                     :key="survey.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row ">
      <div class="col-md-6 form-horizontal">
        <div class="row">
          <label class="col-md-6 col-form-label">Automatic generate schema</label>
          <div class="col-md-6">
            <p-switch v-model="autoSchema" color="black"></p-switch>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <p-button type="success" :disabled="!changed && !canSave" @click="save"><translate>Save</translate></p-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="expostatSurveyInfo">
      <div class="col-md-12">
        <fg-input :placeholder="'Survey name' | translate" :label="'Survey name' | translate" v-model="expostatSurveyInfo.name"></fg-input>
      </div>
    </div>
    <div class="row" v-if="schema">
      <div class="col-md-12">
        <fg-input :placeholder="'Title' | translate" :label="'Title' | translate" v-model="schema.title"></fg-input>
      </div>
    </div>
<!--    <sortable-table @changed="changeOrder">-->
      <el-table :data="schemaTable" style="width: 100%" @current-change="setChanged" ref="schemaTable" row-key="fieldName" :expand-row-keys="expandedRows">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="row">
              <label class="col-md-3 col-form-label" v-translate>Field type</label>
              <div class="col-md-9">
                <el-select class="select-info"
                           :placeholder="'Select field type' | translate"
                           v-model="props.row.type">
                  <el-option v-for="option in fieldTypes"
                             class="select-info"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Title</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Title' | translate" v-model="props.row.title"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Field key</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Field key' | translate" :value="props.row.fieldName" :debounce-events="'blur'" v-debounce:300ms="(v) => {props.row.fieldName = v}"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Placeholder</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Placeholder' | translate" v-model="props.row.placeholder"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Message on error</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Message on error' | translate" v-model="props.row.messageOnError"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Autocapitalize</label>
              <div class="col-md-9">
                <el-select class="select-info"
                           :placeholder="'Select field type' | translate"
                           v-model="props.row.autocapitalize">
                  <el-option v-for="option in autocapitalizeTypes"
                             class="select-info"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              </div>

              <label class="col-md-3 control-label" v-translate v-if="!props.row.visible">Visible rule</label>
              <div class="col-md-9">
                <textarea class="form-control" rows="3" v-model="props.row.visibleIf" v-if="!props.row.visible"></textarea>
              </div>

            </div>
            <div class="row" v-if="props.row.choices">
              <div class="col-md-12">
                <h4><translate>Answer choices:</translate></h4>
                <el-table :data="props.row.choices">
                  <el-table-column :label="'Value' | translate" width="180">
                    <template slot-scope="choice">
                      <fg-input required :placeholder="'Value' | translate" v-model="choice.row.value"></fg-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="'Label' | translate">
                    <template slot-scope="choice">
                      <fg-input required :placeholder="'Label' | translate" v-model="choice.row.label"></fg-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="60">
                    <template slot-scope="choice">
                      <el-tooltip :content="'Delete' | translate" placement="top">
                        <p-button type="danger" size="sm" icon @click="(e) => removeChoice(e, choice.$index, props.row.choices)">
                          <i class="fa fa-times"></i>
                        </p-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
                <el-tooltip :content="'Add choice' | translate" placement="top">
                  <p-button type="success" size="sm" icon @click="(e) => addChoice(e, props.row.choices)">
                    <i class="fa fa-plus"></i>
                  </p-button>
                </el-tooltip>
              </div>
            </div>
<!--            <p>{{ props.row.options }}</p>-->
<!--            <pre>{{ props.row.choices }}</pre>-->
          </template>
        </el-table-column>
        <el-table-column :label="'Name' | translate">
          <template slot-scope="props">
            <p>{{ props.row.title || props.row.fieldName }}<span v-if="props.row.required"> *</span></p>
          </template>
        </el-table-column>
        <el-table-column
          prop="fieldName"
          :label="'Field name' | translate"
          width="180">
          <template slot-scope="props">
            <fg-input :placeholder="'Field key' | translate" v-model="props.row.fieldName"></fg-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Required' | translate"
          width="180">
          <template slot-scope="props">
            <p-switch v-model="props.row.required" color="black"></p-switch>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Visible' | translate"
          width="180">
          <template slot-scope="props">
            <p-switch v-model="props.row.visible" color="black"></p-switch>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="props">
            <el-tooltip :content="'Delete' | translate" placement="top">
              <p-button v-if="!autoSchema" type="danger" size="sm" icon @click="(e) => handleDelete(e, props.$index, props.row)">
                <i class="fa fa-times"></i>
              </p-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-tooltip :content="'Add field' | translate" placement="top">
        <p-button type="success" size="sm" icon @click="(e) => addField()">
          <i class="fa fa-plus"></i>
        </p-button>
      </el-tooltip>
<!--    </sortable-table>-->
  </card>
</template>

<script>
  import {Table, TableColumn, Select, Option, Tooltip} from 'element-ui'
  import {Switch, Card, Button} from 'src/components/UIComponents'
  import {SortableTable} from 'src/components/Expostat/Components'


  export default {
    components: {
      Button,
      Card,
      SortableTable,
      [Tooltip.name]: Tooltip,
      [Switch.name]: Switch,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option
    },
    name: 'SchemaEditor',
    breadcrumb () {
      return {
        label: this.$gettext("Schema editor"),
        parent: {name: 'manage-root'}
      }
    },
    computed: {
      schemaTable () {
        if (this.schema !== null) {
          return this.getSchemaTable(this.schema)
        } else {
          return []
        }
      },
      canSave () {
        return JSON.stringify(this.savedSchema) !== JSON.stringify(this.schema)
      }
    },
    mounted () {
      this.loadSchema()
      this.loadServers()
      this.loadExpostatSurveys()
    },
    data () {
      return {
        currentExpostatSurvey: null,
        expostatSurveyInfo: null,
        expostatSurveys: null,

        currentServer: null,
        servers: null,

        currentDatabase: null,
        databases: null,

        currentSelfRegistration: null,
        selfRegistrations: null,

        currentSurvey: null,
        surveys: null,
        expandedRows: [],

        savedSchema: null,
        schema: null,
        autoSchema: false,
        changed: false,
        newOrdering: null,
        fieldTypes: [
          {value: 'text', label: this.$gettext('Text string')},
          {value: 'phone', label: this.$gettext('Phone')},
          {value: 'date', label: this.$gettext('Date')},
          {value: 'email', label: this.$gettext('E-mail')},
          {value: 'checkboxgroup', label: this.$gettext('Checkbox group')},
          {value: 'radiogroup', label: this.$gettext('Radio group')},
          {value: 'checkbox', label: this.$gettext('Checkbox')},
          {value: 'select', label: this.$gettext('Select')},
          {value: 'switch', label: this.$gettext('Switch')}
        ],
        autocapitalizeTypes: [
          {value: false, label: this.$gettext('Disabled')},
          {value: 'words', label: this.$gettext('By words')},
          {value: 'sentences', label: this.$gettext('By sentences')},
          {value: 'characters', label: this.$gettext('CAPS LOCK')}
        ]
      }
    },
    methods: {
      loadServers () {
        this.axios
          .get('expostat/server/')
          .then(r => r.data)
          .then(servers => {
            this.servers = servers
          })
      },
      loadDatabases () {
        this.currentDatabase = null
        this.databases = null
        this.currentSelfRegistration = null
        this.selfRegistrations = null
        this.axios.get(`${this.currentServer}/api/rforum-settings/database/`)
          .then(r => r.data)
          .then(databases => {
            this.databases = databases
          })
      },
      loadSelfRegistrations () {
        this.currentSelfRegistration = null
        this.selfRegistrations = null
        this.axios.get(`${this.currentServer}/api/rc-terminal/self-registration/?db=${this.currentDatabase}`)
          .then(r => r.data)
          .then(selfRegistrations => {
            this.selfRegistrations = selfRegistrations
          })
        this.loadSurveys()
      },
      loadSurveys () {
        this.currentSurvey = null
        this.surveys = null
        this.axios.get(`${this.currentServer}/api/rc-terminal/survey/?db=${this.currentDatabase}`)
          .then(r => r.data)
          .then(surveys => {
            this.surveys = surveys
          })
      },
      async loadExpostatSurveys () {
        const result = await this.axios.get('survey/surveys/')
        this.expostatSurveys = result.data
      },
      async loadExpostatSurvey () {
        const result = await this.axios.get(`survey/surveys/${this.currentExpostatSurvey}/`)
        this.expostatSurveyInfo = result.data
        this.savedSchema = JSON.parse(JSON.stringify(this.expostatSurveyInfo.schema))
        if (Object.keys(this.expostatSurveyInfo.schema).length === 0) {
          this.schema = JSON.parse(`{
  "$schema": "http://json-schema.org/draft-04/schema#",
  "type": "object",
  "title": "Пожалуйста, заполните персональные данные",
  "properties": {},
  "additional_properties": false,
  "required": []
}`)
        } else {
          this.schema = this.expostatSurveyInfo.schema
        }
      },
      selectSelfRegistration () {
        this.currentSurvey = null
        this.schema = null
        this.savedSchema = null
        this.loadSchema()
      },
      selectSurvey () {
        this.currentSelfRegistration = null
        this.schema = null
        this.savedSchema = null
        this.loadSchema()
      },
      loadSchema () {
        if (this.currentDatabase) {
          let url = null
          if (this.currentSelfRegistration) {
            url = `${this.currentServer}/api/rc-terminal/self-registration/${this.currentSelfRegistration}/schema/?db=${this.currentDatabase}`
          } else if (this.currentSurvey) {
            url = `${this.currentServer}/api/rc-terminal/survey/${this.currentSurvey}/schema/?db=${this.currentDatabase}`
          }
          this.axios.get(url)
            .then(r => r.data)
            .then(data => {
              this.savedSchema = JSON.parse(JSON.stringify(data.schema))
              this.schema = JSON.parse(JSON.stringify(data.schema))
              this.autoSchema = data.autoSchema
            })
        }
      },
      getSchemaTable (schema) {
        if (schema === null || schema.properties === undefined) {
          return []
        }
        return Object.entries(schema.properties).map(e => {
          let fieldName = e[0]
          let options = e[1]

          let type = options.attrs.type || 'text'

          let choices = []
          switch (type) {
            case 'radiogroup':
              choices = options.oneOf || []
              break
            case 'select':
              choices = options.enum || []
              break
            case 'checkboxgroup':
              choices = options.anyOf || []
              break
          }

          return {
            fieldName,
            options,
            choices,
            required: schema.required.includes(e[0]),
            visible: options.visible !== undefined ? options.visible : true,
            type: type,
            visibleIf: options.visibleIf || '',
            title: options.title,
            placeholder: options.attrs.placeholder,
            messageOnError: options.attrs.title,
            autocapitalize: options.attrs.autocapitalize
          }
        })
      },
      getFieldsOrdering (fields) {
        if (fields instanceof Array) {
          return fields.map(e => e.fieldName).map(e => this.camelCaseToUnderscore(e))
        } else {
          return Object.keys(fields).map(e => this.camelCaseToUnderscore(e))
        }
      },
      save () {
        let needOverride = Boolean(this.newOrdering)
        let newData = this.$refs.schemaTable.data
        let oldData = this.getSchemaTable(this.savedSchema)
        let newRequired = newData.filter(r => r.required).map(e => e.fieldName)


        if (this.autoSchema) {
          if (typeof this.schema.autoSchema === 'boolean') {
            this.schema.autoSchema = {}
          }

          if (needOverride) {
            this.schema.autoSchema.ordering = this.newOrdering
          }

          // debugger
          // Сравнение обязательных полей
          if (JSON.stringify(this.savedSchema.required) !== JSON.stringify(newRequired)) {
            this.schema.autoSchema.required = newRequired
          }

          // Получение изменений
          let oldDataObject = oldData.reduce((obj, item) => {
            obj[item.fieldName] = item
            return obj
          }, {})

          let overrides = newData.filter(e => JSON.stringify(oldDataObject[e.fieldName]) !== JSON.stringify(e)).reduce((obj, item) => {
            let _item = JSON.parse(JSON.stringify(item))
            delete _item.fieldName
            delete _item.options
            obj[item.fieldName] = _item
            return obj
          }, {})


          if (Object.keys(overrides).length > 0) {
            this.schema.autoSchema.overrides = this.schema.autoSchema.overrides || {}
            Object.assign(this.schema.autoSchema.overrides, overrides)
          }
        } else {
          // Если не автосхема
          this.schema.properties = this.schemaTable.reduce((obj, field, index) => {
            let result
            if (Object.keys(field.options).length > 0) {
              result = field.options
            } else {
              result = {}
            }

            result.attrs = result.attrs || {}

            result.attrs.type = field.type
            result.title = field.title
            result.visible = field.visible
            result.visibleIf = field.visibleIf
            result.attrs.placeholder = field.placeholder
            result.attrs.title = field.messageOnError
            result.attrs.autocapitalize = field.autocapitalize

            switch (field.type) {
              case 'radiogroup':
                result.oneOf = field.choices
                break
              case 'select':
                result.enum = field.choices
                break
              case 'checkboxgroup':
                result.anyOf = field.choices
                break
            }

            // Определяем тип поля для схемы
            result.type = this.getSchemaFieldType(field.type)


            obj[field.fieldName] = result
            return obj
          }, {})
          this.schema.required = newRequired
        }

        if (this.expostatSurveyInfo) {
          this.axios.patch(`survey/surveys/${this.expostatSurveyInfo.id}/`, {
            schema: this.schema, name: this.expostatSurveyInfo.name
          }).then(r => r.data).then(data => {
            this.expostatSurveyInfo = data
            this.savedSchema = JSON.parse(JSON.stringify(this.expostatSurveyInfo.schema))
            if (Object.keys(this.expostatSurveyInfo.schema).length === 0) {
              this.schema = JSON.parse(`{
  "$schema": "http://json-schema.org/draft-04/schema#",
  "type": "object",
  "title": "Пожалуйста, заполните персональные данные",
  "properties": {},
  "additional_properties": false,
  "required": []
}`)
            } else {
              this.schema = this.expostatSurveyInfo.schema
            }
          })
        }

        if (this.currentDatabase) {
          let url = null
          if (this.currentSelfRegistration) {
            url = `${this.currentServer}/api/rc-terminal/self-registration/${this.currentSelfRegistration}/schema/?db=${this.currentDatabase}`
          } else if (this.currentSurvey) {
            url = `${this.currentServer}/api/rc-terminal/survey/${this.currentSurvey}/schema/?db=${this.currentDatabase}`
          }
          this.axios.put(url, {schema: this.schema, autoSchema: this.autoSchema})
            .then(r => r.data)
            .then(data => {
              this.savedSchema = JSON.parse(JSON.stringify(data.schema))
              this.schema = JSON.parse(JSON.stringify(data.schema))
              this.autoSchema = data.autoSchema
              this.changed = false
            })
        }
      },
      camelCaseToUnderscore(value) {
        return value.replace(/\.?([A-Z]+)/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "")
      },
      changeOrder ({data}) {
        let newOrdering = this.getFieldsOrdering(data)
        let oldOrdering = this.getFieldsOrdering(this.savedSchema.properties)
        if (JSON.stringify(newOrdering) !== JSON.stringify(oldOrdering)) {
          this.newOrdering = newOrdering
          this.setChanged()
        }
      },
      setChanged () {
        if (!this.changed) {
          this.changed = true
        }
      },
      addField () {
        this.schemaTable.push({
          fieldName: 'newField',
          options: {},
          choices: [],
          required: true,
          visible: true,
          type: 'text',
          visibleIf: '',
          title: null,
          placeholder: null,
          messageOnError: null,
          autocapitalize: null
        })
      },
      handleDelete (e, index, row) {
        this.schemaTable.splice(index, 1)
      },
      addChoice (e, choices) {
        choices.push({
          value: null,
          label: null
        })
      },
      removeChoice (e, index, choices) {
        choices.splice(index, 1)
      },
      getSchemaFieldType(name) {
        switch (name) {
          case 'text':
          case 'phone':
          case 'email':
          case 'date':
          case 'radiogroup':
            return 'string'
            break
          case 'select':
            return 'integer'
            break
          case 'checkbox':
          case 'switch':
            return 'boolean'
            break
          default:
            return 'array'
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>
